import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      fontWeight: 700,
      display: 'flex',
      alignItems: 'center'
    },
    default: {
      color: palette.text.primary
    },
    white: {
      color: palette.text.white
    },
    marginTop: {
      marginTop: '20px'
    },
    medium: {
      fontSize: '1.5rem'
    },
    small: {
      fontSize: '1rem'
    },
    semiBold: {
      fontWeight: 600,
      marginRight: '5px'
    },
    title: {
      margin: '0'
    },
    emoji: {
      width: '30px',
      marginLeft: '10px'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
